var _defs, _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 77.67,
    y1: 337.23,
    x2: 387.25,
    y2: -5.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a67d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f9cf5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 60.9,
    y1: 322.09,
    x2: 370.48,
    y2: -20.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 252.71,
    y1: 495.23,
    x2: 562.29,
    y2: 152.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 74.86,
    y1: 334.7,
    x2: 384.44,
    y2: -8.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e59bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7089d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 107.22,
    y1: 363.91,
    x2: 416.8,
    y2: 20.93,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 204.01,
    y1: 451.27,
    x2: 513.59,
    y2: 108.29,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 115.44,
    y1: 371.33,
    x2: 425.03,
    y2: 28.35,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.3,321.73l-5.2,8.8-.8,1.4-17.8,29.8c-8.2,13.6-23.4,22-39.4,22H12.69l86.81-146.81,1.4-2.2,8.8-15c-1.2,17.8,2.8,35.8,12.4,51.4l30.2,50.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M312.91,130.52l-50.6,85.01-5.2-8.8-1-1.6-16.8-29-17,28.6-1,1.6-5,8.6-49.4-82.01-3-4.8,5.2-9,1-1.6,56.2-94.81c5-8.6,17.6-8.6,22.6,0l57.4,97.21,1,1.6,5.6,9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M462.92,383.74h-76.21c-16.2,0-31.2-8.6-39.4-22.8l-16-27.2-1-1.8-5-8.8,50.6-85.81,5.4,8.8,1,1.6,80.61,136.01Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M122.09,271.13l30.2,50.6-5.2,8.8-.8,1.4-33.2-55c-7.4-12.4-12-26-13.6-40l1.4-2.2,8.8-15c-1.2,17.8,2.8,35.8,12.4,51.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "307.31 121.52 312.91 130.52 262.31 215.53 257.1 206.73 256.1 205.13 300.51 129.72 306.31 119.92 307.31 121.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "382.31 247.73 337.31 323.73 331.31 333.73 330.31 331.93 325.31 323.13 375.91 237.33 381.31 246.13 382.31 247.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M477.31,45.73l-76.13,128.46-5.17,8.9-26.07,44.06-50.68,85.85-31.45,53c-2.73,4.59-7.67,7.41-13.01,7.41h-70.78c-5.23,0-10.09-2.74-12.79-7.23l-32.9-54.63-27.21-45.36c-15.14-25.23-15.26-56.73-.3-82.07l27.1-45.92,52.13,86.88,29.58,49.03,28.75-48.41,50.27-85.23,32.41-54.45c14.25-23.94,39.86-38.79,67.71-39.28l58.54-1.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9ceffdd18d371d8817b8bc4db5dfead0.svg";
export { ForwardRef as ReactComponent };